import $ from 'jquery';

var lineChartColors = ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02"];

var unit = "€";
var timeFormat = "MM/YY";

function checkUnit(chartData, chartSelect) {
  var selected = chartSelect[0] && chartSelect[0].value;
  const newunit = chartData[selected] && chartData[selected].unit;
  if (newunit && selected === "employees") {
    unit = "";
  } else if (newunit) {
    unit = newunit;
  }
}

function setInitialData(data, small) {
  var dataSets = [];
  var index = 0;
  Object.keys(data[Object.keys(data)[0]].data).forEach(function(company) {
    dataSets.push({
      label: company,
      data: data[Object.keys(data)[0]].data[company],
      borderWidth: small ? 2 : 4,
      fill: false,
      lineTension: 0,
      borderColor: lineChartColors[index],
      backgroundColor: lineChartColors[index],
      pointBackgroundColor: lineChartColors[index],
      pointBorderColor: small ? "#eff2f2" : "#FFF",
      pointHoverBorderColor: lineChartColors[index],
    });
    if (index < lineChartColors.length - 1) {
      index++;
    } else {
      index = 0;
    }
  });

  return dataSets;
}

function changeChart(select, chart, chartData, hasLegend) {
  if (select) {
    select.change(function() {
      var value = $(this).val();
      var dataSets = [];
      chart.data.datasets.forEach(function(set) {
        if (chartData[value].data[set.label]) {
          set.data = chartData[value].data[set.label];
        } else {
          set.data = null;
        }
      });

      checkUnit(chartData, select);

      chart.update();
      if (hasLegend) {
        updateLegend(chart);
      }
    });
  }
}

function legendCallback(chart) {
  var text = [];
  text.push('<ul class="' + chart.id + '-legend">');
  for (var i = 0; i < chart.data.datasets.length; i++) {
    if (chart.data.datasets[i].data && chart.data.datasets[i].data.length > 0) {
      text.push(
        '<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>'
      );
      if (chart.data.datasets[i].label) {
        text.push(chart.data.datasets[i].label);
      }
      text.push("</li>");
    }
  }
  text.push("</ul>");
  return text.join("");
}

function updateLegend(chart) {
  var compareLegend = document.querySelector("[data-compare-legend]");
  // generate HTML legend
  compareLegend.innerHTML = legendCallback(chart);

  // bind onClick event to all LI-tags of the legend
  var legendItems = compareLegend.getElementsByTagName("li");
  for (var i = 0; i < legendItems.length; i += 1) {
    legendItems[i].addEventListener("click", legendClickCallback, false);
  }
}

function legendClickCallback(event) {
  event = event || window.event;

  var target = event.target || event.srcElement;
  while (target.nodeName !== "LI") {
    target = target.parentElement;
  }
  var parent = target.parentElement;
  var chartId = parseInt(parent.classList[0].split("-")[0], 10);

  // Chart.js v3: Use Chart.getChart() instead of Chart.instances
  var chart = window.Chart.getChart(chartId);
  var index = Array.prototype.slice.call(parent.children).indexOf(target);

  // Toggle dataset visibility
  if (chart.isDatasetVisible(index)) {
    chart.hide(index);
    target.classList.add("inactive");
  } else {
    chart.show(index);
    target.classList.remove("inactive");
  }
}function filterLegendLabel(item, chart) {
  var showLabel = true;
  chart.datasets.forEach(function(set) {
    if (set.label === item.text && (set.data && set.data.length === 0)) {
      showLabel = false;
    }
  });
  return showLabel;
}

function compareChartConfig(data, small) {
  return {
    type: "line",
    data: { datasets: setInitialData(data, small) },
    options: {
      responsive: true,
      maintainAspectRatio: small ? false : true,
      animation: { duration: 500, easing: "easeInOutQuad" },
      hover: { intersect: true, axis: "y", mode: "point" },
      layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
      plugins: {
        tooltip: {
          backgroundColor: "#FFF",
          cornerRadius: 0,
          titleFont: {
            family: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
            size: 14
          },
          bodyFont: {
            family: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
            size: 14
          },
          titleMarginBottom: 8,
          padding: { x: 10, y: 14 },
          displayColors: false,
          borderWidth: 1,
          borderColor: "#d9e0e0",
          titleColor: "black",
          bodyColor: "black",
          caretSize: 8,
          caretPadding: 8,
          callbacks: {
            label: function(context) {
              var label = context.dataset.label || "";

              if (label) {
                label += ": ";
              }
              label +=
                context.parsed.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + unit;
              return label;
            },
          },
        },
        legend: {
          display: false,
          position: "bottom",
          fullWidth: false,
          labels: {
            boxWidth: 20,
            padding: 50,
            font: { size: 16 },
            usePointStyle: true,
            filter: function(item, chart) {
              return filterLegendLabel(item, chart);
            },
          },
        },
      },
      elements: {
        point: {
          radius: small ? 7 : 10,
          borderWidth: 4,
          hitRadius: 20,
          hoverRadius: 10,
        },
      },
      scales: {
        x: {
          type: "time",
          time: {
            parser: timeFormat,
            unit: "month",
            minUnit: "month",
            displayFormats: { month: "M/YY" },
            tooltipFormat: "MMMM YYYY",
          },
          grid: {
            display: true,
            drawBorder: false,
            color: "#d9e0e0",
            tickLength: 10,
            drawOnChartArea: false,
          },
          ticks: {
            font: {
              family: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
              size: 13
            },
            color: "#4f5656",
            maxRotation: 0,
            padding: 8,
          },
        },
        y: {
          grid: {
            display: true,
            color: "#d9e0e0",
            drawBorder: false,
            tickLength: 15,
          },
          ticks: {
            padding: 8,
            font: {
              family: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
              size: 13
            },
            color: "#4f5656",
            callback: function(value, index, values) {
              // Maximum rotation for tick labels when rotating to condense labels. // Padding between the tick label and the axis.
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + unit;
            },
          },
        },
      },
    },
  };
}

$(document).on("turbo:load", function() {
  // Access Chart from window inside the event handler
  const Chart = window.Chart;

  if (!Chart) {
    console.error('Chart.js is not available');
    return;
  }

  moment.locale("fi");
  var compareChart = $("[data-compare-line-chart]");

  if (compareChart && compareChart.length > 0) {
    var chartData = compareChart.data("chartData");
    var chartSelect = $("[data-chart-select]");

    var chart = new Chart(compareChart, compareChartConfig(chartData));

    updateLegend(chart);

    changeChart(chartSelect, chart, chartData, true);
  }

  var companyCharts = $("[data-company-line-chart]");
  if (companyCharts && companyCharts.length > 0) {
    companyCharts.each(function(index, companyChart) {
      var chartData = $(companyChart).data("chartData");
      if (chartData) {
        var chartParent = companyChart.closest(".company-card__chart");
        var chartSelect = $(chartParent).find("select");
        checkUnit(chartData, chartSelect);
        var chart = new Chart(companyChart, compareChartConfig(chartData, true));
        changeChart(chartSelect, chart, chartData, false);
      }
    });
  }

  // Register the vertical line plugin (only once)
  // This draws a vertical line on hover to point
  if (!window.verticalLinePluginRegistered) {
    const verticalLinePlugin = {
      id: 'verticalLineOnHover',
      afterDatasetsDraw: function(chart) {
        const chart_type = chart.config.type;
        if (chart.tooltip._active && chart.tooltip._active.length && chart_type === "line") {
          const activePoint = chart.tooltip._active[0];
          const ctx = chart.ctx;
          const x = activePoint.tooltipPosition().x;
          const topY = chart.scales['y-axis-0'].top;
          const bottomY = chart.scales['y-axis-0'].bottom;

          // draw line
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(x, topY + 1);
          ctx.lineTo(x, bottomY - 1);
          ctx.setLineDash([3, 6]);
          ctx.lineWidth = 1;
          ctx.strokeStyle = "#9ca3a3";
          ctx.stroke();
          ctx.restore();
        }
      },
    };
    Chart.pluginService.register(verticalLinePlugin);
    window.verticalLinePluginRegistered = true;
  }
});
